import { LocationOnOutlined, LuggageOutlined } from "@mui/icons-material";
import {
  Autocomplete,
  CircularProgress,
  ListItemButton,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Baseline from "../../../../components/form/Baseline";
import {
  getTravels,
  selectTravelsByFilter,
} from "../../../../store/features/travelsSlice";
import SelectorBox from "../SelectorBox";

function TravelInput({
  value,
  onChange,
  readOnly,
  size,
  variant = "filled",
  isEditable = true,
  margin = "dense",
  role = "personal",
  disabled,
  placeholder = "Adicionar a uma viagem",
}) {
  const dispatch = useDispatch();

  const { status } = useSelector((state) => state.travels.personal);

  const options = useSelector((state) =>
    selectTravelsByFilter(state, role, "available", null)
  );

  const loading = status === "loading";

  const onOpen = () => {
    dispatch(
      getTravels({
        role,
        status: "available",
        clearCache: true,
      })
    );
  };

  if (!isEditable) {
    return (
      <Baseline
        Icon={LuggageOutlined}
        value={value?.title}
        emptyLabel={"Nenhuma viagem"}
        label={value?.title ? "Viagem" : ""}
      />
    );
  } else {
    return (
      <SelectorBox Icon={LuggageOutlined} active={Boolean(value)}>
        <Autocomplete
          fullWidth
          loading={loading}
          onOpen={onOpen}
          value={value || null}
          readOnly={readOnly}
          autoHighlight
          options={options || []}
          size={size || "small"}
          disabled={disabled}
          isOptionEqualToValue={(option, value) => option?._id === value?._id}
          onChange={(e, v) => {
            onChange(v || "");
          }}
          getOptionLabel={(option) => option?.title || ""}
          renderOption={(props, option, state) => {
            return (
              <ListItemButton
                {...props}
                key={option?._id}
                selected={state.selected}
              >
                <LuggageOutlined
                  color="primary"
                  sx={{ mr: 1.5, mb: 3, ml: -0.5 }}
                />
                <ListItemText
                  slotProps={{
                    primary: {
                      fontWeight: 600,
                    },
                  }}
                  primary={option?.title}
                  secondary={
                    <>
                      {Boolean(option?.notes) && (
                        <Typography mb={0.5} noWrap variant="inherit">
                          {option?.notes}
                        </Typography>
                      )}
                      <Stack direction={"row"} gap={0.5} alignItems={"center"}>
                        <LocationOnOutlined
                          color="action"
                          sx={{ fontSize: ".9rem" }}
                        />
                        <Typography noWrap variant="inherit">
                          {option?.to}
                        </Typography>
                      </Stack>
                    </>
                  }
                />
              </ListItemButton>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              margin={margin}
              multiline
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={15} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
              fullWidth
              variant={variant}
              placeholder={placeholder}
            />
          )}
        />
      </SelectorBox>
    );
  }
}

export default memo(TravelInput);
